module.exports = __webpack_public_path__ + "static/img/9_10commitments_SF6.4cab258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/9_10commitments_SF6.jpg
// module id = WB86
// module chunks = 0